<template>
  <div class="mt-2">
    <Select2
      v-model="myValue"
      :options="myOptions"
      :settings="{
        placeholder: placeholder ? placeholder : '-- Kies lid –',
        width: '100%',
      }"
      @select="mySelectEvent($event)"
    />

    <div v-if="this.isEdit" class="row mt-3">
      <div class="col-md-12 col-12">
        <ul class="flex-container list-unstyled">
          <li
            class="p-2 m-1 container-bg"
            v-for="(value, index) in committee.users"
            v-bind:key="'edit_com_member' + index"
          >
            {{ value.display_name }}
            <i
              class="fas fa-times ml-2 text-danger"
              style="cursor: pointer"
              v-on:click="deleteEditCommitteemembers(value.id)"
            ></i>
          </li>
        </ul>
      </div>
    </div>
    <div v-else class="row mt-3">
      <div class="col-md-12 col-12">
        <ul class="flex-container list-unstyled">
          <li
            class="p-2 m-1 container-bg"
            v-for="value in selections"
            v-bind:key="'com_member_' + action + '_' + value.id"
          >
            {{ value.text }}
            <i
              class="fas fa-times ml-2 text-danger"
              style="cursor: pointer"
              v-on:click="deleteSelection(value.id)"
            ></i>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "members",
  props: {
    isEdit: null,
    committee: null,
    userId: null,
    placeholder: null,
    action: { default: "addSelectedMembers" },
    group: null,
  },
  data() {
    return {
      myValue: "",
      myOptions: [],
    };
  },
  computed: {
    ...mapState({
      selectedMembers: (state) => state.selectedMembers,
      selectedInfoGroupMembers: (state) => state.selectedInfoGroupMembers,
      members: (state) => state.members,
    }),
    selections() {
      return this.action == "addSelectedInfoGroupMembers"
        ? this.selectedInfoGroupMembers
        : this.selectedMembers;
    },
  },
  methods: {
    mySelectEvent() {
      var newOptions = [];
      this.myOptions.forEach((item) => {
        var obj = {
          id: item.id,
          text: item.text,
          disabled: item.id == this.myValue ?? false,
        };
        //selectedValue
        if (item.id == this.myValue) {
          if (this.isEdit) {
            var result = this.members.find((d) => d.id == obj.id);
            if (!result) return false;
            if (this.$parent.committee) {
              this.$parent.committee.users.push(result);
            }
            this.$store.state.selectedMembers.push(obj);
            return false;
          } else {
            if (this.action == "addSelectedInfoGroupMembers") {
              this.$store.state.selectedInfoGroupMembers.push(obj);
            } else {
              this.$store.state.selectedMembers.push(obj);
            }
          }
        }
        newOptions.push(obj);
      });
      this.myOptions = newOptions;
      this.myValue = "";
    },
    deleteSelection(value) {
      var newOptions = [];
      this.myOptions.forEach((item) => {
        var disabled = item.disabled;
        var id = item.id;
        var text = item.text;
        if (item.id == value) {
          disabled = false;
        }
        var obj = {
          id,
          text,
          disabled,
        };

        newOptions.push(obj);
        //selectedValue
        this.$store.state.selectedMembers.forEach((item, index) => {
          if (item.id == value) {
            this.$store.state.selectedMembers.splice(index, 1);
          }
        });
      });
      this.myOptions = newOptions;
    },
    deleteEditCommitteemembers(id) {
      this.$parent.committee.users = this.$parent.committee.users.filter(
        (d) => d.id != id
      );
      this.$store.state.selectedMembers = this.$store.state.selectedMembers.filter(
        (d) => d.id != id
      );
    },
  },
  async created() {
    this.myValue = this.userId;

    if (this.users == null) {
      await this.$store.dispatch("get", "api/v1/active/users").then((data) => {
        var newOptions = [];
        data.data.data.forEach((item) => {
          var disabled = item.disabled;
          var id = item.id;
          var text = item.display_name;
          var obj = {
            id,
            text,
            disabled,
          };

          if (this.userId == id) {
            this.$store.commit("addSelectedMembers", obj);
          }
          newOptions.push(obj);
        });
        this.$store.state.members = [...data.data.data];
        this.myOptions = newOptions;
        /* if(!this.isEdit){
            this.$store.state.selectedMembers=[];
        } */
      });
    } else {
      this.users.forEach((item) => {
        var disabled = item.disabled;
        var id = item.id;
        var text = item.display_name;
        var obj = {
          id,
          text,
          disabled,
        };
        if (this.userId == id) {
          this.$store.commit("addSelectedMembers", obj);
        }
        this.newOptions.push(obj);
      });
    }
  },
  watch: {
    isEdit: function() {
      var newOptions = [];

      if (this.isEdit) {
        this.$store.state.selectedMembers = [];
        if (!this.committee.users) return false;
        this.committee.users.forEach((user) => {
          var disabled = true;
          var id = user.id;
          var text = user.display_name;

          var obj = {
            id,
            text,
            disabled,
          };

          newOptions.push(obj);
        });
        this.myOptions = newOptions;
        //selectedValue
        this.$store.state.selectedMembers = newOptions;
      } else {
        this.myOptions.forEach((item) => {
          var disabled = false;
          var id = item.id;
          var text = item.text;
          var obj = {
            id,
            text,
            disabled,
          };

          newOptions.push(obj);
        });
        this.myOptions = newOptions;
        this.$store.state.selectedMembers = [];
      }
    },

    group(value) {
      if (value) {
        let membArr = value.members;
        if (membArr.length) {
          let filteredMem = this.$store.state.members
            .filter((item) => {
              return membArr.includes(item.id);
            })
            .map((item) => {
              return {
                id: item.id,
                text: item.display_name,
                disabled: item.disabled,
              };
            });

          this.$store.commit("addSelectedInfoGroupMembers", ...filteredMem);
        }
      }
    },
  },
};
</script>

<style scoped>
.form-control,
.input-group-text {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #00000029;
  border-radius: 4px;
  opacity: 1;
  border: 1px #ced4da;
}
.flex-container {
  display: flex;
  flex-flow: row wrap;
  position: relative;
  width: auto;
  align-items: center;

  opacity: 1;
}
</style>
